import {
  GET_CUSTOMER_REFUND_REQUEST,
  GET_CUSTOMER_REFUND_SUCCESS,
  GET_CUSTOMER_REFUND_ERROR
} from "./types";
import axios from "axios";
import { BASEURL } from "../../constant/config.js";
import moment from "moment";

export const getcustomerRefundRepotNew = (token, values) => (dispatch) => {

  dispatch({ type: GET_CUSTOMER_REFUND_REQUEST });
  const newData = {
    from_date: moment(values.from_date).format("MM-DD-YYYY"),
    to_date: moment(values.to_date).format("MM-DD-YYYY"),
    refund_header_no: values.refund === undefined ? null : values.refund,
    customer_id: values.customer === undefined || values.customer === "All" || values.customer.length  === 0 ? null : values.customer,
    account_id: values.debit_account === "All" ? null : values.debit_account,
    ar_account_id: values.account === "All" ? null : values.account,
  };
  return axios({
    method: "POST",
    url: `${BASEURL}getAll/RefundSummaryAr`,
    headers: {
      Accept: "application/json",
      Authorization: "Bearer " + token,
    },
    data: newData,
  })
    .then((response) => {
      return dispatch({
        type: GET_CUSTOMER_REFUND_SUCCESS,
        payload: response.data,
      });
    })
    .catch((error) => {
      dispatch({
        type: GET_CUSTOMER_REFUND_ERROR,
        payload: [],
      });
    });
};
